import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filterTableDataAPI } from "services/CRUDServices"

export const filterCapacity: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "capacity-managemnt",
  async (body: any) => {
    const data = await filterTableDataAPI(
      "/consignment-api/consignmentCapacity/filter",
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    )

    return data.data.payload
  }
)

const initialState: any = {
  CapacityData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const DefineCapacitySlice = createSlice({
  initialState: initialState,
  name: "capacity-managemnt",
  reducers: {
    clearCapacity: (state) => {
      state.CapacityData = []
    },
    setCapacityFilter: (state, action) => {
      state.filter = action.payload
    },

  },
  extraReducers: {
    [filterCapacity.fulfilled as any]: (state, action) => {
      state.CapacityData = action.payload
      state.fetchpost = false
    },
    [filterCapacity.pending as any]: (state) => {
      state.fetchpost = true
    },
    [filterCapacity.rejected as any]: (state) => {
      state.fetchpost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setCapacityFilter, clearCapacity } =
  DefineCapacitySlice.actions
export default DefineCapacitySlice.reducer
